export enum ProductEvaluateStatusEnum
    {
        Not_Started = "Not_Started",
        All_Evaluated = "All_Evaluated",
        Parital_Evaluated = "Parital_Evaluated"
    }
